module.exports = __webpack_public_path__ + "img/bg.8475c94.jpg";